export default __webpack_public_path__ + "static/media/Josh Newman.90be18ba.jpg";